import { useEffect, useState } from "react";
import api from "../api/client";
import { useToast } from "../store/toast";
import { Modal } from "./ui";
import { abrirPdfEnNuevaPestana } from "../utils";

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function EmailPicker({ label, contactos, seleccionados, onChange, libres, onLibresChange }) {
  const [nuevo, setNuevo] = useState("");
  const toggle = (id) => {
    onChange(seleccionados.includes(id) ? seleccionados.filter((x) => x !== id) : [...seleccionados, id]);
  };
  const agregarLibre = () => {
    const email = nuevo.trim();
    if (!EMAIL_RE.test(email)) return;
    if (!libres.includes(email)) onLibresChange([...libres, email]);
    setNuevo("");
  };
  return (
    <div>
      <label className="label">{label}</label>
      <div className="max-h-32 space-y-1 overflow-y-auto rounded-lg border border-slate-200 p-2">
        {contactos.length === 0 && <p className="text-xs text-slate-400">Sin contactos del directorio para este proyecto.</p>}
        {contactos.map((c) => (
          <label key={c.id} className="flex items-center gap-2 text-sm">
            <input type="checkbox" checked={seleccionados.includes(c.id)} onChange={() => toggle(c.id)} />
            <span>{c.nombre} <span className="text-slate-400">({c.email})</span></span>
          </label>
        ))}
      </div>
      <div className="mt-1 flex flex-wrap gap-1">
        {libres.map((e) => (
          <span key={e} className="flex items-center gap-1 rounded-tag bg-slate-100 px-2 py-0.5 text-xs">
            {e}
            <button type="button" onClick={() => onLibresChange(libres.filter((x) => x !== e))}>×</button>
          </span>
        ))}
      </div>
      <div className="mt-1 flex gap-1">
        <input className="input !h-8 flex-1 text-sm" placeholder="otro correo…" value={nuevo}
          onChange={(e) => setNuevo(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), agregarLibre())} />
        <button type="button" className="btn-ghost px-2 text-xs" onClick={agregarLibre}>Agregar</button>
      </div>
    </div>
  );
}

export default function ConstanciaModal({ projectId, task, open, onClose, onSent }) {
  const { push } = useToast();
  const [contactos, setContactos] = useState([]);
  const [destinatarioIds, setDestinatarioIds] = useState([]);
  const [destinatariosLibres, setDestinatariosLibres] = useState([]);
  const [ccIds, setCcIds] = useState([]);
  const [ccLibres, setCcLibres] = useState([]);
  const [notaFinal, setNotaFinal] = useState("");
  const [previewHtml, setPreviewHtml] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    setDestinatarioIds([]); setDestinatariosLibres([]); setCcIds([]); setCcLibres([]);
    setNotaFinal(""); setPreviewHtml("");
    api.get(`/projects/${projectId}/checklists/${task.id}/constancia/destinatarios`)
      .then((r) => setContactos(r.data)).catch(() => setContactos([]));
  }, [open, projectId, task?.id]);

  const cargarPreview = async () => {
    const r = await api.get(`/projects/${projectId}/checklists/${task.id}/constancia/preview`,
      { params: { nota_final: notaFinal } });
    setPreviewHtml(r.data.html);
  };

  const descargarPdf = () => {
    abrirPdfEnNuevaPestana(
      async () => (await api.get(`/projects/${projectId}/checklists/${task.id}/constancia/pdf`,
        { params: { nota_final: notaFinal }, responseType: "blob" })).data,
      { onError: () => push("No se pudo generar el PDF", "error") },
    );
  };

  const enviar = async () => {
    if (destinatarioIds.length + destinatariosLibres.length === 0) {
      push("Elige al menos un destinatario", "error");
      return;
    }
    setBusy(true);
    try {
      await api.post(`/projects/${projectId}/checklists/${task.id}/constancia/enviar`, {
        destinatario_ids: destinatarioIds, destinatarios_libres: destinatariosLibres,
        cc_ids: ccIds, cc_libres: ccLibres, nota_final: notaFinal,
      });
      push("Constancia enviada", "success");
      onSent?.();
      onClose();
    } catch (err) {
      push(err.response?.data?.detail || "No se pudo enviar la constancia", "error");
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose} title="Enviar constancia">
      <div className="space-y-4">
        <EmailPicker label="Destinatario" contactos={contactos} seleccionados={destinatarioIds}
          onChange={setDestinatarioIds} libres={destinatariosLibres} onLibresChange={setDestinatariosLibres} />
        <EmailPicker label="CC (opcional)" contactos={contactos} seleccionados={ccIds}
          onChange={setCcIds} libres={ccLibres} onLibresChange={setCcLibres} />
        <div>
          <label className="label">Nota final (opcional)</label>
          <textarea className="input" rows={3} value={notaFinal} onChange={(e) => setNotaFinal(e.target.value)} />
        </div>
        <button type="button" className="btn-ghost text-sm" onClick={cargarPreview}>Vista previa</button>
        {previewHtml && (
          <iframe title="Vista previa" sandbox="" srcDoc={previewHtml}
            className="h-64 w-full rounded-lg border border-slate-200" />
        )}
        <div className="flex justify-end gap-2 pt-2">
          <button type="button" className="btn-ghost" onClick={descargarPdf}>Descargar PDF</button>
          <button type="button" className="btn-primary" disabled={busy} onClick={enviar}>
            {busy ? "Enviando…" : "Enviar por email"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
